import "./MenuEventItem.scss"

import { EventDto } from "@/entities/app/menu/menu.dto"
import ButtonIcon from "@/shared/components/intrinsic/Button/ButtonIcon"
import Icon from "@/shared/components/intrinsic/Icon/Icon"
import Expander from "@/shared/components/extrinsic/Expander/Expander"

import MenuEventPreview from "../MenuEventPreview/MenuEventPreview"


interface MenuEventItemProps {
  event: EventDto
  expanded: boolean
  companyId: string
  onToggle: () => void
  onEdit?(): void
  onDelete?(): void
}

function MenuEventItem(props: MenuEventItemProps) {
  const hasDesign = props.event.designId != null

  return (
    <div className="menu-event-item">
      <div className="menu-event-item__header">
        <div className="menu-event-item__icon">
          <Icon name={hasDesign ? "calendar_success" : "calendar_pending"} />
        </div>
        <button
          type="button"
          className="menu-event-item__name"
          onClick={props.onToggle}
        >
          {props.event.name}
        </button>
        <div className="menu-event-item__actions">
          <ButtonIcon
            size="small"
            color="transparent"
            name="trash-bin"
            onClick={props.onDelete}
            ariaLabel="Delete Event"
          />
        </div>
      </div>

      <Expander expanded={props.expanded}>
        <MenuEventPreview
          event={props.event}
          companyId={props.companyId}
          onEdit={props.onEdit || (() => {})}
        />
      </Expander>
    </div>
  )
}

export default MenuEventItem
